
import React from 'react';
import { cn } from "@/lib/utils";

interface AvatarProps {
  src: string;
  alt: string;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, className }) => {
  return (
    <div className={cn("relative overflow-hidden animate-float", className)}>
      <div className="absolute inset-0 bg-gradient-to-b from-leo-purple/30 to-leo-lavender/30 rounded-3xl" />
      <img 
        src={src} 
        alt={alt} 
        className="relative z-10 object-contain w-full h-full"
      />
    </div>
  );
};

export default Avatar;
